<hive-button
    class="follow-up-chip"
    data-testid="follow-up-chip"
    emphasis="tertiary"
    size="small"
    [icon]="faSparkles"
    [label]="text()"
    hiveTooltip
    [hiveTooltipDescription]="text()"
    (click)="onClick()"
></hive-button>
